export default {
  scrollToProductId: (id) => {
    if (id) {
      const element = document.getElementById(`prd-list-${id}`);
      if (element) {
        const position = element.getBoundingClientRect();
        window.scrollTo(0, (window.scrollY + position.top - 75));
      } else {
        const list = document.getElementById("prd-list");
        if (list) {
          const position = list.getBoundingClientRect();
          window.scrollTo(0, (window.scrollY + position.top - 75));
        }
      }
    } else {
      window.scrollTo(0, 0);
    }
  }
};
